document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        const form = document.getElementById('form-items');

        if (!form) {
            return;
        }

        console.log('Formulario encontrado:', form);
        const cartUrl = form.getAttribute('data-cart-url'); // Obtener URL del carrito desde el atributo

        function checkSubscriptionProducts() {
            console.log('Verificando productos en el carrito...');

            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    console.log('Carrito obtenido:', cart);

                    if (!cart.items || cart.items.length === 0) {
                        console.log('El carrito está vacío, redirigiendo al carrito normal.');
                        form.action = cartUrl;
                        form.method = 'post';
                        return;
                    }

                    // Verificar si hay al menos un producto con el tag 'suscripcion'
                    const hasSubscription = cart.items.some(item => {
                        const tags = Array.isArray(item.product_tags) ? item.product_tags :
                                     (typeof item.product_tags === 'string' ? item.product_tags.split(',') : []);
                        return tags.includes('suscripcion');
                    });

                    console.log('¿Hay productos con suscripción?', hasSubscription);

                    // Redirigir según la presencia de productos de suscripción
                    if (hasSubscription) {
                        form.action = '/pages/subscription-checkout';
                        form.removeAttribute('method');
                        console.log('Redirigiendo a suscripción:', form.action);
                    } else {
                        form.action = cartUrl;
                        form.method = 'post';
                        console.log('Redirigiendo al carrito normal:', form.action);
                    }
                })
                .catch(error => console.error('Error obteniendo el carrito:', error));
        }

        checkSubscriptionProducts();
        document.addEventListener('cart:updated', checkSubscriptionProducts);

        // Detectar cambios en el carrito usando MutationObserver
        const cartElement = document.querySelector('[data-cart-items]'); // Asegúrate de que este selector es correcto
        if (cartElement) {
            const observer = new MutationObserver(() => {
                console.log('Cambio detectado en el carrito. Verificando suscripción...');
                checkSubscriptionProducts();
            });

            observer.observe(cartElement, { childList: true, subtree: true });
        } else {
            console.warn('No se encontró el contenedor de productos del carrito para observar cambios.');
        }

        // Detectar cuando se agrega un producto al carrito
        document.querySelectorAll('[data-action="add-to-cart"]').forEach(button => {
            button.addEventListener('click', () => {
                console.log('Producto agregado al carrito. Verificando suscripción...');
                setTimeout(checkSubscriptionProducts, 1500); // Espera para asegurar actualización
            });
        });

        // Detectar cuando se elimina un producto del carrito
        document.querySelectorAll('[data-cart-tool_action][data-id="remove"]').forEach(button => {
            button.addEventListener('click', () => {
                console.log('Producto eliminado del carrito. Verificando suscripción...');
                setTimeout(checkSubscriptionProducts, 1500); // Espera para asegurar actualización
            });
        });

    }, 500);
});
